<template>
	<v-layout align-center justify-center>
		<v-flex xs2>
			<v-text-field
				browser-autocomplete="off"
				class="ma-2"
				v-model="searchFields.code"
				:label="isProject ? 'Numer wniosku' : 'Numer oferty'"
				aria-label="project code"
			></v-text-field>
		</v-flex>
		<v-flex xs3>
			<v-autocomplete
				browser-autocomplete="off"
				class="ma-2"
				:items="contestNames"
				v-model="searchFields.contestName"
				:label="isProject ? 'Nazwa naboru' : 'Nazwa konkursu'"
				aria-label="contest name"
				clearable
			></v-autocomplete>
		</v-flex>
		<v-flex xs2>
			<v-layout align-center justify-center>
				<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
				<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	import {Pagination} from "@/utils/PaginationUtils";
	import {Api} from "@/api";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "ContestOfferEvaluationsFilters",

    mixins: [Filters],

		data() {
			return {
				searchFields: Pagination.initSearchedFields([
					"contestName",
					'code'
				]),
				search: "",
				contestNames: []
			};
		},

		props: {
			value: {},
			isProject: {},
			evaluationType: {}
		},

		created () {
			Api.get(this, "/" + this.evaluationType + "-evaluation/contest-names", successResponse => {
					this.contestNames = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować nazw " +
						(this.isProject ? "naborów" : "konkursów"), errorResponse);
				});
		},

    mounted () {
      this.searchFields = this.retrieveFilters(this.searchFields);
      this.buildNewSearch();
    },

		methods: {
			resetSearch() {
				Pagination.resetSearch(this.searchFields);
				this.search = "";
				this.buildNewSearch();
			},

			buildNewSearch() {
				this.search = Pagination.buildSearchCriteria(this.searchFields, false);
				this.$emit('input', this.search);
			},
		}

	};
</script>

<style scoped>

</style>